// Default RPG character sheet structure
// Coordinates assume a 1200px wide canvas.

const uid = () => Math.random().toString(36).slice(2, 10);

export const PRESET_SILHOUETTES = [
  { key: "knight",  label: "Hero",
    url: "https://static.prod-images.emergentagent.com/jobs/9d7a7a96-cfaa-4032-bbb9-c78d2d79db34/images/e7a060bd338524570b977a4b068797fdce57fc2c0e5aa9a56362987412a450f7.png" },
];

export function defaultBoxes() {
  return [
    {
      id: uid(), type: "identity", title: "Identity",
      x: 0, y: 0, w: 1200, h: 200,
      fields: [
        { label: "Name", value: "" },
        { label: "Role", value: "" },
        { label: "Level", value: "", num: true },
        { label: "Credo", value: "" },
        { label: "Values", value: "" },
      ],
      fullWidthField: { label: "Destiny", value: "" },
    },
    {
      id: uid(), type: "stats", title: "Stats",
      x: 0, y: 220, w: 280, h: 320,
      rows: [
        { label: "Strong",   value: "" },
        { label: "Nimble",   value: "" },
        { label: "Healthy",  value: "" },
        { label: "Sensible", value: "" },
        { label: "Smart",    value: "" },
        { label: "Social",   value: "" },
      ],
    },
    {
      id: uid(), type: "skills", title: "Skills",
      x: 0, y: 560, w: 280, h: 380,
      rows: Array.from({ length: 7 }).map(() => ({ label: "", value: "" })),
      allowAdd: true,
    },
    {
      id: uid(), type: "equipment", title: "Equipment",
      x: 920, y: 220, w: 280, h: 720,
      rows: Array.from({ length: 14 }).map(() => ({ value: "" })),
      allowAdd: true,
    },
    {
      id: uid(), type: "achievements", title: "Achievements",
      x: 300, y: 780, w: 300, h: 200,
      rows: Array.from({ length: 5 }).map(() => ({ value: "" })),
      allowAdd: true,
    },
    {
      id: uid(), type: "goals", title: "Goals",
      x: 620, y: 780, w: 300, h: 200,
      rows: Array.from({ length: 5 }).map(() => ({ value: "" })),
      allowAdd: true,
    },
    {
      id: uid(), type: "notes", title: "Notes",
      x: 0, y: 1000, w: 1200, h: 180,
      rows: Array.from({ length: 4 }).map(() => ({ value: "" })),
      allowAdd: true,
    },
  ];
}

export function defaultSilhouette() {
  return { type: "preset", value: "knight", x: 320, y: 220, w: 580, h: 720 };
}

export function newCustomBox(x = 60, y = 60) {
  return {
    id: uid(), type: "custom", title: "New Box",
    x, y, w: 280, h: 220,
    rows: Array.from({ length: 4 }).map(() => ({ value: "" })),
    allowAdd: true,
  };
}

export { uid };
